import React, { KeyboardEvent } from 'react'

import { ColorSwatch, SelectMark } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'
import { useCollectionFiltersContext } from '../../containers/CollectionFiltersContext'

import { AppliedLabel, AppliedLabelWrap, Body, ClearAll, CloseWrap, LabelText } from './styles'

interface IProps {
  clearAllFilters: () => void
  selectedFilters: Record<string, string[]>
  toggleSelectedFilter: (key: string, value: string) => void
}

export const AppliedFilterLabels: React.FC<IProps> = ({
  clearAllFilters,
  selectedFilters,
  toggleSelectedFilter,
}) => {
  const { colors } = useCollectionFiltersContext()
  const {
    collections: {
      filtering: { desktopFilterBar: desktopFilterBarCopy },
    },
  } = useTranslation()

  const handleKeyDownClearAll = (e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      clearAllFilters()
    }
  }

  const handleKeyDownSelectedFilters = (filter: string, value: string, e: KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      toggleSelectedFilter(filter, value)
    }
  }

  return (
    <Body>
      <AppliedLabelWrap>
        {selectedFilters && Object.keys(selectedFilters).length > 0 && (
          <ClearAll
            role='button'
            tabIndex={0}
            onClick={clearAllFilters}
            onKeyDown={e => handleKeyDownClearAll(e)}
          >
            {desktopFilterBarCopy.clearAllFiltersCta}
          </ClearAll>
        )}
        {selectedFilters &&
          Object.keys(selectedFilters)?.map((filter, index) => (
            <React.Fragment key={`${filter}-${index}`}>
              {selectedFilters[filter]?.map(value => {
                const color = colors[value]
                return (
                  <AppliedLabel
                    key={`${filter}-${value}`}
                    tabIndex={0}
                    role='button'
                    onClick={() => {
                      toggleSelectedFilter(filter, value)
                    }}
                    onKeyDown={(e: KeyboardEvent) => {
                      handleKeyDownSelectedFilters(filter, value, e)
                    }}
                  >
                    {color && color.hexCodes && (
                      <ColorSwatch
                        hexCodes={color.hexCodes}
                        hover={false}
                        selected={false}
                        swatchUrl={color.swatchUrl}
                      />
                    )}
                    <LabelText>{value}</LabelText>
                    <CloseWrap>
                      <SelectMark />
                    </CloseWrap>
                  </AppliedLabel>
                )
              })}
            </React.Fragment>
          ))}
      </AppliedLabelWrap>
    </Body>
  )
}
